var map = {
	"./pr-1.png": "e302",
	"./pr-2.png": "b46e",
	"./pr-3.png": "8685",
	"./pr-4.png": "ce1d",
	"./pr-5.png": "3126",
	"./pr-6.png": "3aac",
	"./pr-7.png": "cbca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a6c0";